import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppLocalStorage } from 'app/app-storage-manager/local-storage';
import { AuthHeaderService } from 'app/shared/auth-header.service';
import { MiscService } from 'app/shared/misc.service';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class ProductsService {
    constructor(
      private http: HttpClient,  
      private authHeaderService: AuthHeaderService,
      private miscService: MiscService
    ) { }

    getMerchantProducts = () => this.http.get(`${environment.API_URL}/products/merchant/${this.miscService.getMerchantDetails().merchant_id}`)

    createProductCategory = (resource) => this.http.post(`${environment.API_URL}/merchant/product`, resource)

    getProductCategory = () => this.http.get(`${environment.API_URL}/merchant/categories/${this.miscService.getMerchantDetails().merchant_id}`)
    
    fetchInsuranceCategories = (): Observable<any> => {
        const xAuthHeader = this.authHeaderService.generateAuthHeader({});
        const headers = new HttpHeaders()
          .set('X-Auth-Signature', xAuthHeader)
          .set('X-APP-ID', `${environment.X_APP_ID}`)
          .set('X-ISSUER-ID', `${environment.X_ISSUER_ID}`);
    
        return this.http.get(`${environment.API_URL2}/xas/v1/merchants/fetch/products/categories?type=insurance`, { headers });
    }

    createProduct = (resource) => this.http.post(`${environment.API_URL}/products`, resource)

    createInvestmentProduct = (payload: any): Observable<any> => 
      this.http.post(`${environment.API_URL}/investment`, payload)

    toggleProductStatus = (status: string, merchant_id: string, session_id: string, product_id: string): Observable<any> => 
      this.http.put(`${environment.API_URL}/investment/merchant/update/${status}/${merchant_id}/${session_id}/${product_id}`, '')

    editProduct = (resource) => this.http.put(`${environment.API_URL}/products`, resource)

    updateInvestmentProduct = (payload: any): Observable<any> => this.http.put(`${environment.API_URL}/investment/update`, payload)

    deleteProduct = (id: string): Observable<any> => this.http.delete(`${environment.API_URL2}/transactions-service/product/${id}`,)

    uploadTerms = (payload: any, merchant_id: string): Observable<any> => this.http.put(`${environment.API_URL}/investment/upload/terms/investment/${merchant_id}`, payload)

}